import { HIDE_SIDEBAR, SHOW_SIDEBAR, TOOGLE_SIDEBAR, SET_HEADER_TITLE, HOME_CLICK } from "../constants";

const initialState = {
  isSideBar: false,
  headerTitle: '',
  homeClick: false
};

const layoutReducer = (state = initialState, action = null) => {
  switch (action.type) {

    case SHOW_SIDEBAR:
      return {
        ...state,
        isSideBar: true,
      };
    case HIDE_SIDEBAR:
      return {
        ...state,
        isSideBar: false,
      };
      case HOME_CLICK:
      return {
        ...state,
        homeClick:action.payload
      }
    case SET_HEADER_TITLE:
      return {
        ...state,
        headerTitle: action.payload,
      };
    case TOOGLE_SIDEBAR:
      return {
        ...state,
        isSideBar: !state.isSideBar,
      };
    default:
      return state;
  }
};

export default layoutReducer;
